<div *ngIf="classLabel$ | async as className">
  {{ className }}
</div>
